export class UImage {
  public static readonly AVATAR_FOLDER = "avatars";
  public static readonly LOGO_FOLDER = "logos";

  private static readonly AVATAR_CONTENT_TYPES = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/heic",
    "image/heif",
  ];

  private static readonly AVATAR_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".webp",
    ".heic",
    ".heif",
  ];

  public static isValidMimeType(file: File): boolean {
    return file.type.startsWith("image/");
  }

  public static isValidAvatarMimeType(file: File): boolean {
    return UImage.AVATAR_CONTENT_TYPES.includes(file.type);
  }

  public static getContentTypes(): string[] {
    return [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
      "image/svg+xml",
      "image/bmp",
      "image/tiff",
      "image/heic",
      "image/heif",
    ];
  }

  public static getAvatarContentTypes(): string[] {
    return [...UImage.AVATAR_CONTENT_TYPES];
  }

  public static getAvatarExtensions(): string[] {
    return [...UImage.AVATAR_EXTENSIONS];
  }

  public static isAvatarPath(pathname: string): boolean {
    return pathname.includes(`/${UImage.AVATAR_FOLDER}/`);
  }

  public static isImagePath(pathname: string): boolean {
    return (
      pathname.includes(`/${UImage.AVATAR_FOLDER}/`) || pathname.includes(`/${UImage.LOGO_FOLDER}/`)
    );
  }

  public static hasValidAvatarExtension(url: string): boolean {
    const path = url.toLowerCase().split("?")[0];
    return UImage.AVATAR_EXTENSIONS.some((ext) => path.endsWith(ext));
  }
}
